import styled, { css } from 'styled-components'

import { TextAreaProps } from './TextArea'

export type InputProps = TextAreaProps & {
  $hasError: boolean
}

const errorStyles = ({ $hasError }: InputProps) =>
  $hasError &&
  css`
    border-color: ${({ theme: { colors } }) => colors.error};
  `

const disabledStyles = ({ disabled }: InputProps) =>
  disabled &&
  css`
    border-color: ${({ theme: { colors } }) => colors.disabled};
    background: #fff;
    color: ${({ theme: { colors } }) => colors.disabled};
  `

export const Input = styled.textarea<InputProps>`
  width: 100%;
  height: ${({ theme: { layout } }) => layout.spacing(25)};
  border: 1px solid ${({ theme: { border } }) => border.color};
  border-radius: ${({ theme: { border } }) => border.radius};
  padding: ${({ theme: { layout } }) => layout.spacing(2)};
  color: ${({ theme: { colors } }) => colors.text};
  font-weight: 400;
  font-size: 1rem;
  font-family: ${({ theme: { fontFamily } }) => fontFamily.default};
  ${errorStyles}
  ${disabledStyles}

  &::-webkit-input-placeholder {
    color: #ccc;
  }

  &:focus {
    font-weight: 500;
  }

  &:focus-visible {
    outline: none;
  }
`
